import React from 'react';
import { Box, NakedButton, Text } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';
import ToggleContent from '@shared/v2/components/ToggleContent';

import BookingConditionsModal from '@/components/BookingConditionsModal';

const BookingConditions = () => {
  return (
    <ToggleContent
      toggle={(open) => (
        <Box color="greys.steel" fontSize="sm">
          <Skeleton height="1.5rem" maxWidth="530px">
            Cancellation fees may apply (up to 100% of total booking price).
            &nbsp;
            <NakedButton onClick={open}>
              <Text textDecoration="underline" fontSize="sm">
                Booking Conditions
              </Text>
            </NakedButton>
          </Skeleton>
        </Box>
      )}
      content={(close) => <BookingConditionsModal close={close} />}
    />
  );
};

export default BookingConditions;
